import type { IGatsbyImageData } from 'gatsby-plugin-image';

type ImageArgs = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  width: number;
  height: number;
  layout?: IGatsbyImageData['layout'];
  loader: (args: {
    src: string;
    width: number;
    height: number;
    quality: string | number;
  }) => string;
};

export default function getCloudinaryImage({
  src,
  width,
  height,
  layout = 'fixed',
  loader,
  ...rest
}: ImageArgs): IGatsbyImageData {
  return {
    layout,
    width,
    height,
    images: {
      fallback: {
        ...rest,
        src: loader({ src, width, height, quality: 'auto' }),
        srcSet: `${loader({
          src,
          width: width * 2,
          height: height * 2,
          quality: 'auto',
        })} 2x,
          ${loader({
            src,
            width: width * 3,
            height: height * 3,
            quality: 'auto',
          })} 3x`,
      },
    },
  };
}
